module.exports = __webpack_public_path__ + "static/media/iconfont.6773320d.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/iconfont.ico
// module id = 116
// module chunks = 0